import React, { useState, useEffect } from 'react';
import { Grid, TextField } from 'components/mui';
import RichTextEditor from 'components/RichTextEditor';
import { CaseFormData, CaseValidation } from 'containers/pages/cases/types';
import searchStatuses, { StatusOption } from 'api/cases/searchStatuses';
import FormAutocomplete, { ensureOption } from 'containers/pages/cases/components/caseForm/FormAutocomplete';
import FormSection from 'containers/pages/cases/components/caseForm/FormSection';

interface CaseInfoSectionProps {
	form: CaseFormData;
	valid: CaseValidation;
	onFieldChange: (e: { target: { name: string; value: string } }) => void;
	onStatusChange: (_event: unknown, value: StatusOption | null) => void;
}

const CaseInfoSection: React.FC<CaseInfoSectionProps> = ({
	form,
	valid,
	onFieldChange,
	onStatusChange,
}) => {
	const [statuses, setStatuses] = useState<StatusOption[]>([]);

	useEffect(() => {
		searchStatuses('').then(setStatuses).catch(() => {});
	}, []);

	const statusValue: StatusOption | null = form.StatusId
		? { Id: Number(form.StatusId), Title: form.StatusTitle }
		: null;
	const statusOptions = ensureOption(statuses, statusValue);

	return (
		<FormSection title="Case Information">
			<Grid container spacing={2}>
				<Grid item xs={12} sm={8}>
					<TextField
						label="Title"
						name="Title"
						value={form.Title}
						onChange={onFieldChange}
						required
						error={valid.Title.isErr}
						helperText={valid.Title.errMsg}
						fullWidth
						size="small"
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<FormAutocomplete
						label="Status"
						required
						options={statusOptions}
						value={statusValue}
						onChange={onStatusChange}
						getOptionLabel={(opt) => opt.Title}
						onSearch={(val) => searchStatuses(val).then(setStatuses).catch(() => {})}
						error={valid.StatusId.isErr}
						helperText={valid.StatusId.errMsg}
					/>
				</Grid>
				<Grid item xs={12}>
					<RichTextEditor
						value={form.Description}
						onChange={(content: string) =>
							onFieldChange({ target: { name: 'Description', value: content } })
						}
						height={200}
						placeholder="Enter case description..."
					/>
				</Grid>
				<Grid item xs={12}>
					<TextField
						label="Status Comment"
						name="StatusComment"
						value={form.StatusComment}
						onChange={onFieldChange}
						multiline
						minRows={2}
						maxRows={4}
						fullWidth
						size="small"
					/>
				</Grid>
			</Grid>
		</FormSection>
	);
};

export default CaseInfoSection;
